import classNames from "classnames";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { saveStoreData } from "../../features/login/LoginSlice";
import ChangeStoreModal from "./ChangeStoreModal";

import { useChangeStoreHeader } from "./useChangeStoreHeader";

const ChangeStoreHeader = () => {
  const { storeId, storeName, stores, loading, fetchStores, initiallyHadData } =
    useChangeStoreHeader();

  const location = useLocation();

  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);

  const handleStoreChange = (store) => {
    dispatch(
      saveStoreData({
        storeId: store.iStoreId,
        storeName: store.sName,
      })
    );
    setShowModal(false);
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  return (
    <div className="p-2.5">
      <div className="flex flex-row justify-between items-center lg:min-h-[38px]">
        <h1>{storeName}</h1>
        <div className="flex gap-4 items-center justify-end">
          <div className="flex items-center gap-6">
            {(!(stores.length > 1) && !initiallyHadData) || (
              <Button
                variant="outline-secondary"
                className={classNames(
                  "border border-gray-500 focus:outline-none outline-none px-3 bg-gray-50",
                  { invisible: loading && !initiallyHadData }
                )}
                onClick={() => setShowModal(true)}
              >
                Change Store
              </Button>
            )}
            <img
              alt="iaugment-logo"
              src="/iAugment-logo-color.png"
              className="h-8 max-w-full object-contain"
            />
          </div>
        </div>
      </div>
      <ChangeStoreModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleStoreChange={handleStoreChange}
        stores={stores}
        loading={loading}
        storeId={storeId}
        fetchStores={fetchStores}
        storeName={storeName}
      />
    </div>
  );
};

export default ChangeStoreHeader;
